export default __webpack_public_path__ + "static/media/not-found.0394b952.svg";